import { render, staticRenderFns } from "./PendingAcceptanceTable.vue?vue&type=template&id=0cce2b80"
import script from "./PendingAcceptanceTable.vue?vue&type=script&lang=js"
export * from "./PendingAcceptanceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports